import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function DeleteConfirmModal({ isOpen, onClose, onConfirm, title, itemName, isLoading }) {
  const warningBg = useColorModeValue('red.50', 'red.900');

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="2xl" mx={4}>
        <ModalHeader>Delete {title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="center" py={4}>
            <Icon
              as={() => <FontAwesomeIcon icon={faExclamationTriangle} />}
              boxSize={12}
              color="red.500"
              p={4}
              bg={warningBg}
              borderRadius="full"
            />
            <Text textAlign="center">
              Are you sure you want to delete <strong>{itemName}</strong>?
            </Text>
            <Text fontSize="sm" color="gray.500" textAlign="center">
              This action cannot be undone. All associated data will be permanently removed.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="ghost" onClick={onClose} borderRadius="xl">
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={onConfirm}
            isLoading={isLoading}
            borderRadius="xl"
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeleteConfirmModal;
